module.exports = __webpack_public_path__ + "static/__background.f181b610.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/__background.jpg
// module id = 1590
// module chunks = 35783957827783